<template>
   <div style="background-color: white">


      <!--<Section background="white"  class="image-bg"-->
      <!--         :style="{'background-image': `url(${require('../../assets/images/content/pexels-pixabay-33153.jpg')})`}"-->

      <!--&gt;-->

      <!--   &lt;!&ndash;<nav-bar dark></nav-bar>&ndash;&gt;-->

      <!--   <div class=" main-heading" style=" width: 100%;" >-->
      <!--      <v-container fluid class="heading-line">-->

      <!--         <div class="center display-2">Original Music</div>-->
      <!--         <div class="center display-1">By Mieko</div>-->


      <!--      </v-container>-->
      <!--   </div>-->


      <!--</Section>-->


      <div style="height: 30px">

      </div>

      <div class="pl-3 pr-3">
         <!--<div style="display: flex; justify-content: space-evenly; flex-wrap: wrap">-->
         <!--   <div-->
         <!--          v-for="cd in cds" :key="cd.path"-->
         <!--          style="width: 18%"-->
         <!--   >-->
         <!--      <v-img-->
         <!--          :src="cd.path+'front.jpg'"-->
         <!--          @click="select(cd)"-->
         <!--          style="cursor: pointer"-->
         <!--          :style="cd_border_style(cd)"-->
         <!--      />-->
         <!--   </div>-->
         <!--</div>-->

         <v-row>
            <v-col cols="2"
                v-for="cd in cds" :key="cd.path"
                style="width: 18%"
            >
               <v-img
                   :src="cd.path+'front.jpg'"
                   @click="select(cd)"
                   style="cursor: pointer; "
                   :style="cd_border_style(cd)"
               />
            </v-col>
         </v-row>




      </div>

      <div style="height: 30px">

      </div>

      <div v-if="selected_cd!=null"
          style="display: flex; justify-content: center">
         <table>
            <tr>
               <th></th>
               <th style="text-align: left">Song</th>
               <th>Player Controls</th>
            </tr>

            <tr
                v-for="(item, ix) in selected_cd.files" :key="ix"
                style="border-bottom:5px solid red; "
            >
               <td style="min-width: 70px">
                  {{ix+1}}
               </td>
               <td >
                  {{item.title}}
               </td>
               <td style="width:300px">
                  <AudioPlayer :file="item.file" :path="selected_cd.path"/>
               </td>
            </tr>
         </table>
      </div>




   </div>
</template>

<script>
import navBar from "@/components/navBar";
import Section from "@/components/Section";
import AudioPlayer from "@/components/AudioPlayer";

import files from '@/assets/data/living_the_bible_q_clean.json'

export default {
   name: "CDPlayer",
   components: {navBar, Section, AudioPlayer},
   data(){
      return {
         selected_cd: null,

         cds: [
            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_001/',
               files: [
                  {file:'1_Isaiah_53.mp3', title:'Isaiah 53'},
                  {file:'2_Psalm_22.mp3', title:'Psalm 22'},
                  {file:'3_Isaiah_43.mp3', title:'Isaiah 43'},
                  {file:'4_Psalm_23.mp3', title:'Psalm 23'},
                  {file:'5_Psalm_15.mp3', title:'Psalm 15'},
                  {file: '6_1_Corinthian_13.mp3', title: '1st Corinthian 13'}
               ],
            },
            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_002/',
               files: [
                  {file:'1_John_3_16-21.mp3', title:'John 3:16-21'},
                  {file:'2_Psalms_91.mp3', title:'Psalm 91'},
                  {file:'3_Ten_Commandments.mp3', title:'The Ten Commandments'},
                  {file:'4_Gal_5_19-26.mp3', title:'galatians 5:19-26 '},
                  {file:'5_Phillipian_4_4-8.mp3', title:'5 Phillipian 4:4-8'},
                  {file:'6_Mica_6_6-8.mp3', title:'Mica 6:6-8'},
                  {file:'7_Mica_7_18-20.mp3', title:'Mica 7:18-20'},
                  {file:'8_Psalms_37_1-11.mp3', title:'Psalm 37:1-11'},
                  {file:'9_Isaiah_55.mp3', title:'Isaiah 55'},

               ],
            },
            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_003/',
               files: [
                  {file:'1_Matthew_5_1-19.mp3', title:'Matthew 5:1-19'},
                  {file:'2_Psalms_37_1-11.mp3', title:'Psalms 37:1-11'},
                  {file:'3_Phil_2_5-16.mp3', title:'Philippians 2:5-16'},
                  {file:'4_Ephes_6_10-18.mp3', title:'Ephesians 6:10-18'},
                  {file:'5_Rev_21_1-8.mp3', title:'Revelations 21:1-8'},


               ],
            },
            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_004/',
               files: [
                  {file:'1_I_Stand_Before_Thy_Cross.mp3', title:'I Stand Before Thy Cross'},
                  {file:'2_I_Sing_The_Song.mp3', title:'I Sing The Song'},
                  {file:'3_I_Have_Failed_My_Lord.mp3', title:'I Have Failed My Lord'},
                  {file:'4_The_Lord_is_Calling_New.mp3', title:'The Lord is Calling New'},
                  {file:'5_I_Hear_the_Children_Cry.mp3', title:'I Hear the Children Cry'},
                  {file:'6_Why_Are_You_Sad.mp3', title:'Why Are You Sad'},
                  {file:'7_Precious_Jewel.mp3', title:'Precious Jewel'},
                  {file:'8_The_Lord_Is_Watching_Over_Me.mp3', title:'The Lord Is Watching Over Me'},

               ],
            },
            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_005/',
               files: [
                  {file:'1_Isaiah_58.mp3', title:'Isaiah 58'},
                  {file:'2_Romans_8_1-39.mp3', title:'Romans 8:1-39'},
               ],
            },

            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_006/',
               files: [
                  {file:'Revelation_12.mp3', title:'Revelation 12'},
                  {file:'Revelation_13.mp3', title:'Revelation 13'},
                  {file:'Revelation_14.mp3', title:'Revelation 14'},

               ],
            },

            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_007/',
               files: [
                  {file:'Revelation_1_(1-20).mp3', title:'Revelation 1'},
                  {file:'Revelation_12.mp3', title:'Revelation 12'},
               ],
            },
            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/melody_cross_008/',
               files: [
                  {file:'1_Calvary\'s_Love_Complete.mp3', title:'Calvary\'s Love Complete'},
                  {file:"2_Take_Up_Thy_Cross.mp3", title:"Take Up Thy Cross"},
                  {file:"3_The_Love_of_God.mp3", title:"The Love of God"},
                  {file:"4_Two_Sets_of_Footprints.mp3", title:"Two Sets of Footprints"},
                  {file:"5_Lord's_Prayer.mp3", title:" Lord's Prayer"},
                  {file:"6_It_Is_Finished.mp3", title:" It Is Finished"},
               ],
            },
            {
               path: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/music/family_project/',
               files: [
                  {file:'FAMILY_MUSIC.mp3', title:'Family Music'},
                  {file:"GETHSEMANE.mp3", title:"Gethsemane"},
                  {file:"GOD\'S_PROMISE.mp3", title:"God's Promise"},
                  {file:"JAPANESE_OLD_HYMN.mp3", title:"Japanese Old Hymn"},
               ],
            }
         ]
      }
   },
   methods:{
      select(cd){
         this.selected_cd = cd;
      },

      cd_border_style(cd){
         let ans = '';
         if (cd.path === this.selected_cd.path){
            ans = 'border: 5px solid #05ec0e';
            // ans = '#05ec0e'
         }
         return ans;
      }
   },
   created(){
      this.selected_cd = this.cds[0];
   }
}
</script>

<style scoped>
.image-bg{
    background-size: cover;
    background-position: center;
    height: 300px;
}

td{
    padding-left: 10px;
    padding-right: 10px;
}


.main-heading{
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;

}


.heading-line{
    text-align: center;
    color:#ffffff;
    /*background-color:rgba(43,43,43,0.4);*/
    width: 100%;

}

</style>